const SaleOrder_sample = [
  {
    orderData: {
      sodtt_id: "sodtt_id",
      store_id: "store_id",
      cmr_phone_number: "cmr_phone_number",
      sodtt_total_gst: "sodtt_total_gst",
      sodtt_total_discount: "sodtt_total_discount",
      sodtt_payment_status: "sodtt_payment_status",
      sodtt_transaction_id: "sodtt_transaction_id",
      sodtt_order_status: "sodtt_order_status",
      sodtt_sub_total: "sodtt_sub_total",
      sodtt_payment_method: "sodtt_payment_method",
      sodtt_billing_address: "sodtt_billing_address",
      sodtt_total_amount: "sodtt_total_amount",
      sodtt_round_off_value: "sodtt_round_off_value",
      sodtt_delivery_date: "sodtt_delivery_date",
      sodtt_document_date: "sodtt_document_date",
      is_invoice_created: "is_invoice_created",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      cmr_id: "cmr_id",
      remarks: "remarks",
      created_date: "created_date",
      update_date: "update_date",
      inv_no: "inv_no",
      document_date: "document_date",
      tds_tcs_type: "tds_tcs_type",
      tcs_or_tds_percentage: "tcs_or_tds_percentage",
      tcs_or_tds_amount: "tcs_or_tds_amount",
      tcs_or_tds_percentage_id: "tcs_or_tds_percentage_id",
      sodtt_invoice_discount: "sodtt_invoice_discount",
      sodtt_invoice_discount_percentage: "sodtt_invoice_discount_percentage",
      sodtt_is_invoice_dis_percentage: "sodtt_is_invoice_dis_percentage",
      sodtt_ship_to_address: {
        cmr_id: "cmr_id",
        update_date: "update_date",
        created_date: "created_date",
        cmr_default_address: "cmr_default_address",
        cmr_ship_address_id: "cmr_ship_address_id",
        cmr_ship_address_city: "cmr_ship_address_city",
        cmr_ship_address_name: "cmr_ship_address_name",
        cmr_ship_address_town: "cmr_ship_address_town",
        cmr_ship_address_state: "cmr_ship_address_state",
        cmr_ship_address_street: "cmr_ship_address_street",
        cmr_ship_address_address: "cmr_ship_address_address",
        cmr_ship_address_country: "cmr_ship_address_country",
        cmr_ship_address_pincode: "cmr_ship_address_pincode",
        cmr_ship_address_district: "cmr_ship_address_district"
      },
      sodtt_pay_to_address: {
        cmr_id: "cmr_id",
        update_date: "update_date",
        created_date: "created_date",
        cmr_pay_address_id: "cmr_pay_address_id",
        cmr_default_address: "cmr_default_address",
        cmr_pay_address_city: "cmr_pay_address_city",
        cmr_pay_address_name: "cmr_pay_address_name",
        cmr_pay_address_town: "cmr_pay_address_town",
        cmr_pay_address_state: "cmr_pay_address_state",
        cmr_pay_address_street: "cmr_pay_address_street",
        cmr_pay_address_address: "cmr_pay_address_address",
        cmr_pay_address_country: "cmr_pay_address_country",
        cmr_pay_address_pincode: "cmr_pay_address_pincode",
        cmr_pay_address_district: "cmr_pay_address_district"
      }
    },
    itemData: [
      {
        item_id: "item_id",
        item_code: "item_code",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        item_pack_size: "item_pack_size",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        sott_id: "sott_id",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_batch_number: "item_batch_number",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_batch_quantity: "item_batch_quantity",
        is_item_invoice_created: "is_item_invoice_created",
        item_exp_date: "item_exp_date",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_uom: "item_uom",
        item_uom_id: "item_uom_id",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        item_free_quantity: "item_free_quantity",
        item_to_be_delivered: "item_to_be_delivered",
        itemBatchData: [
          {
            item_batch_number: "item_batch_number",
            item_id: "item_id",
            item_batch_quantity: "item_batch_quantity",
            item_exp_date: "item_exp_date",
            item_batch_purchase_rate: "item_batch_purchase_rate",
            item_batch_unit_price: "item_batch_unit_price",
            item_uom_id: "item_uom_id",
            from_bin_location: "from_bin_location",
            item_batch_sales_rate: "item_batch_sales_rate",
            from_bin_id: "from_bin_id",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_total_sales_rate: "item_batch_total_sales_rate",
            item_batch_final_sales_rate: "item_batch_final_sales_rate",
            item_batch_total_base_sales_rate: "item_batch_total_base_sales_rate",
            item_batch_discounted_sales_rate: "item_batch_discounted_sales_rate"
          }
        ],
        total_sellable_quantity: "total_sellable_quantity"
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {SaleOrder_sample,storeDetailsResult_sample};